import styled from 'styled-components';

export const VisuallyHidden = styled.div`
  ${props => props.theme.visuallyHidden}
`;
